import './styles/feedback.css'
import logo from './logo_color.svg'

import React, {Component} from 'react'
import {connect} from 'react-redux'
import {Route, Switch, withRouter} from 'react-router-dom'
import {Grid} from 'react-bootstrap'
import {NotificationContainer, NotificationManager} from 'react-notifications'

import FeedbackPage from './pages/Feedback'

class AppNoAuth extends Component {
  constructor(props) {
    super(props)
    props.history.listen(location => {
      if (location.state && location.state.message) {
        window.scrollTo(0, 0)
        if (location.state.type === 'error') {
          NotificationManager.error(location.state.message, location.state.title)
        } else {
          NotificationManager.success(location.state.message, location.state.title)
        }
      }
    })
  }

  componentWillMount() {
    // Assign classes to upper levels that differ from main App
    let root = document.getElementsByTagName('html')[0]
    root.setAttribute('class', 'feedback-outer')

    document.body.classList.add("feedback-body")
  }

  render() {
    if (this.props.location.pathname.indexOf('/public') !== 0) {
      this.props.keycloakSession.login()
      return null
    }

    return (
      <div>
        <div className="feedback-bg"></div>
        <div className="logo-color"><img src={logo} alt="logo"/></div>
        <NotificationContainer/>
        <Grid className="feedback-container">
          <Switch>
            <Route exact path='/public/feedback/:uuid' component={FeedbackPage}/>
          </Switch>
        </Grid>
      </div>
    )
  }
}

export default withRouter(
  connect(
    state => {
      return {}
    }, {}
  )(AppNoAuth)
)


// WEBPACK FOOTER //
// ./src/AppNoAuth.js